export const consolidationPrepareSteps = {
    UPDATED_FEEDBACK: 'UPDATED_FEEDBACK',
    NO_FEEDBACK: 'NO_FEEDBACK',
    ONLY_USER_FEEDBACK: 'ONLY_USER_FEEDBACK',
    ONLY_PM_RATING: 'ONLY_PM_RATING',
    ONLY_TL_RATING: 'ONLY_TL_RATING',
    MANAGER_RATING: 'MANAGER_RATING'
};
